import { NativeStackScreenProps } from '@react-navigation/native-stack'
import { Box, useTheme } from 'native-base'
import React from 'react'
import ResumeComponent from '../components/ResumeComponent'
import { RootStackProps } from './Home'

type Props = NativeStackScreenProps<RootStackProps, 'Resume'>;

const Resume = ({ navigation }: Props) => {
  const { colors } = useTheme()

  return (
    <Box style={{ backgroundColor: colors.primary[50] }}>
      <ResumeComponent navigation={navigation} />
    </Box>
  )
}

export default Resume
